// @ts-strict-ignore
import {
  Background,
  BlurbContainer,
  Container,
  ContentLockup,
  Header,
  HeaderWrapper,
  ImageContainer,
  ImageText,
  ImageTitle,
  ImageWrapper,
  Images,
  TitleText
} from './Steps.styles';
import IconMoneyHandDS from './IconMoneyHandDS';
import IconTradeChironDS from './IconTradeChironDS';
import IconMoneyDS from './IconMoneyDS';

const IMAGE_WIDTH = 56;
const IMAGE_HEIGHT = 56;

const Steps = () => (
  <Background>
    <Container>
      <ContentLockup>
        <HeaderWrapper>
          <Header>How it works</Header>
          <TitleText>Trade in or sell your vehicle to Carvana in just a few easy steps.</TitleText>
        </HeaderWrapper>
      </ContentLockup>
      <Images>
        <ImageContainer>
          <ImageWrapper>
            <IconMoneyHandDS width={IMAGE_WIDTH} height={IMAGE_HEIGHT} />
          </ImageWrapper>
          <BlurbContainer>
            <ImageTitle>Get your offer</ImageTitle>
            <ImageText>
              Share a few vehicle details and we’ll extend a real offer in 2 minutes. No haggling.
              No hassles.
            </ImageText>
          </BlurbContainer>
        </ImageContainer>

        <ImageContainer>
          <ImageWrapper>
            <IconTradeChironDS width={IMAGE_WIDTH} height={IMAGE_HEIGHT} />
          </ImageWrapper>
          <BlurbContainer>
            <ImageTitle>Trade-in or sell</ImageTitle>
            <ImageText>Trade in your old vehicle for a new one, or sell it to Carvana.</ImageText>
          </BlurbContainer>
        </ImageContainer>

        <ImageContainer>
          <ImageWrapper>
            <IconMoneyDS width={IMAGE_WIDTH} height={IMAGE_HEIGHT} />
          </ImageWrapper>
          <BlurbContainer>
            <ImageTitle>Get paid</ImageTitle>
            <ImageText>
              We’ll do a quick, on-site review of your vehicle and pay you on the spot.
            </ImageText>
          </BlurbContainer>
        </ImageContainer>
      </Images>
    </Container>
  </Background>
);

export default Steps;
